import { useEffect, useState } from "react";
import {
  DEFAULT_MAINTENANCE_CONFIG,
  fetchMaintenanceConfig,
  isMaintenanceEnabledByEnv,
  MaintenanceConfig,
} from "src/config/maintenance";

export const useMaintenanceMode = () => {
  const [active, setActive] = useState(false);
  const [config, setConfig] = useState<MaintenanceConfig>(DEFAULT_MAINTENANCE_CONFIG);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const resolveMaintenance = async () => {
      try {
        const remoteConfig = await fetchMaintenanceConfig();
        if (cancelled) return;

        const enabled = isMaintenanceEnabledByEnv() || remoteConfig.enabled;
        setConfig(remoteConfig);
        setActive(enabled);
      } catch {
        if (!cancelled) {
          setActive(isMaintenanceEnabledByEnv());
          setConfig(DEFAULT_MAINTENANCE_CONFIG);
        }
      } finally {
        if (!cancelled) setReady(true);
      }
    };

    resolveMaintenance();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!active) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [active]);

  return { active, config, ready };
};
